// {
//   "name": "iconic-frequently-bought-together.js",
//   "author": "Arham Web Works",
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(function () {
  const CART_ADD_URL = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  const CART_URL = (window.routes && window.routes.cart_url) || '/cart';

  function getCurrency() {
    return (
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      document.documentElement.getAttribute('data-currency') ||
      'USD'
    );
  }

  function formatMoney(cents, currencySymbol) {
    if (currencySymbol) {
      return currencySymbol + (cents / 100).toFixed(2);
    }
    var formatted = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: getCurrency(),
      currencyDisplay: 'symbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);
    return formatted.replace(/^US\s*/i, '');
  }

  function getVariantFromRow(row) {
    var available = true;
    const select = row.querySelector('[data-fbt-variant-select]');
    if (select) {
      var opt = select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
      if (!opt || !opt.value) {
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value && !select.options[i].disabled) {
            opt = select.options[i];
            break;
          }
        }
      }
      if (opt && opt.value) {
        available = opt.dataset.available !== 'false' && opt.dataset.available !== false;
        return { id: String(opt.value), price: parseInt(opt.dataset.price, 10), compare: parseInt(opt.dataset.compare, 10) || 0, available: available };
      }
    }
    const hidden = row.querySelector('[data-fbt-variant-id]');
    if (hidden && hidden.value) {
      available = hidden.dataset.available !== 'false' && hidden.dataset.available !== false;
      return { id: String(hidden.value), price: parseInt(hidden.dataset.price, 10), compare: parseInt(hidden.dataset.compare, 10) || 0, available: available };
    }
    return null;
  }

  function updateRowSoldOut(row) {
    var soldOutEl = row.querySelector('[data-fbt-sold-out]');
    var cb = row.querySelector('[data-fbt-checkbox]');
    var v = getVariantFromRow(row);
    if (v && !v.available) {
      if (soldOutEl) {
        soldOutEl.style.display = '';
        soldOutEl.setAttribute('aria-hidden', 'false');
      }
      row.classList.add('iconic-fbt-row--sold-out');
      if (cb) { cb.checked = false; cb.disabled = true; }
    } else {
      if (soldOutEl) {
        soldOutEl.style.display = 'none';
        soldOutEl.setAttribute('aria-hidden', 'true');
      }
      row.classList.remove('iconic-fbt-row--sold-out');
      if (cb) { cb.disabled = false; }
    }
  }

  function updateRowPrice(row, currencySymbol) {
    const priceEl = row.querySelector('[data-fbt-row-price]');
    if (!priceEl) return;
    const v = getVariantFromRow(row);
    if (!v) return;
    const sym = currencySymbol || '';
    let html = '<span class="iconic-fbt-current-price">' + formatMoney(v.price, sym) + '</span>';
    if (v.compare && v.compare > v.price) {
      let pct = Math.round(((v.compare - v.price) / v.compare) * 100);
      html += ' <s class="iconic-fbt-compare-price">' + formatMoney(v.compare, sym) + '</s>';
    }
    priceEl.innerHTML = html;
    updateRowSoldOut(row);
  }

  function getSelectedTotal(container) {
    let total = 0;
    container.querySelectorAll('.iconic-fbt-row').forEach(function (row) {
      const cb = row.querySelector('[data-fbt-checkbox]');
      if (!cb || !cb.checked) return;
      const v = getVariantFromRow(row);
      if (v && v.available) total += v.price;
    });
    return total;
  }

  function updateTotal(container) {
    const totalEl = container.querySelector('[data-fbt-total]');
    const originalWrap = container.querySelector('[data-fbt-original-wrap]');
    const originalEl = container.querySelector('[data-fbt-original-total]');
    const btn = container.querySelector('[data-fbt-add-selected]');
    if (!totalEl) return;
    const total = getSelectedTotal(container);
    const enableDiscount = container.dataset.fbtEnableDiscount === 'true';
    const discountPct = parseInt(container.dataset.fbtDiscountPercentage || '0', 10) || 0;
    const discountedTotal = enableDiscount && discountPct > 0 && total > 0
      ? Math.round(total * (1 - discountPct / 100))
      : total;
    const sym = container.dataset.currencySymbol || '';

    if (originalWrap && originalEl) {
      if (enableDiscount && discountPct > 0 && total > 0) {
        originalWrap.style.display = '';
        originalEl.textContent = formatMoney(total, sym);
        totalEl.textContent = formatMoney(discountedTotal, sym);
        totalEl.classList.add('iconic-fbt-total-discounted');
      } else {
        originalWrap.style.display = 'none';
        originalEl.textContent = '';
        totalEl.textContent = total ? formatMoney(total, sym) : formatMoney(0, sym);
        totalEl.classList.remove('iconic-fbt-total-discounted');
      }
    } else {
      totalEl.textContent = (enableDiscount && discountPct > 0 && total > 0) ? formatMoney(discountedTotal, sym) : (total ? formatMoney(total, sym) : formatMoney(0, sym));
      totalEl.classList.toggle('iconic-fbt-total-discounted', !!(enableDiscount && discountPct > 0 && total > 0));
    }
    if (btn) {
      var hasAnyAvailable = false;
      container.querySelectorAll('.iconic-fbt-row').forEach(function (row) {
        var cb = row.querySelector('[data-fbt-checkbox]');
        if (cb && cb.checked) {
          var v = getVariantFromRow(row);
          if (v && v.available) hasAnyAvailable = true;
        }
      });
      var enabled = total > 0 && hasAnyAvailable;
      btn.disabled = !enabled;
      var gridBar = container.querySelector('[data-fbt-grid-bar]');
      if (gridBar) {
        if (enabled) {
          gridBar.classList.add('iconic-fbt-grid-bar--has-selection');
        } else {
          gridBar.classList.remove('iconic-fbt-grid-bar--has-selection');
        }
      }
    }
    updateVisualVisibility(container);
  }

  function updateVisualVisibility(container) {
    var visualRow = container.querySelector('.iconic-fbt-visual-row');
    if (!visualRow) return;
    container.querySelectorAll('.iconic-fbt-row').forEach(function (row) {
      var idx = row.getAttribute('data-index');
      if (idx === null) return;
      var cb = row.querySelector('[data-fbt-checkbox]');
      var visible = cb ? cb.checked : true;
      var item = visualRow.querySelector('.iconic-fbt-visual-item[data-fbt-index="' + idx + '"]');
      if (item) {
        if (visible) {
          item.style.removeProperty('display');
          item.classList.remove('iconic-fbt-visual-item--hidden');
          var img = item.querySelector('img');
          if (img) img.style.removeProperty('display');
        } else {
          item.style.setProperty('display', 'none', 'important');
          item.classList.add('iconic-fbt-visual-item--hidden');
          var img = item.querySelector('img');
          if (img) img.style.setProperty('display', 'none', 'important');
        }
      }
    });
    // Plus after item K: show when row K is checked AND any later row is checked (so plus appears between consecutive visible products)
    visualRow.querySelectorAll('.iconic-fbt-plus').forEach(function (plus) {
      var afterIdx = plus.getAttribute('data-fbt-plus-after');
      if (afterIdx === null) return;
      var k = parseInt(afterIdx, 10);
      var rowK = container.querySelector('.iconic-fbt-row[data-index="' + k + '"]');
      var cbK = rowK ? rowK.querySelector('[data-fbt-checkbox]') : null;
      var currentChecked = cbK && cbK.checked;
      var hasLaterChecked = false;
      container.querySelectorAll('.iconic-fbt-row').forEach(function (row) {
        var idx = parseInt(row.getAttribute('data-index'), 10);
        if (idx > k) {
          var cb = row.querySelector('[data-fbt-checkbox]');
          if (cb && cb.checked) hasLaterChecked = true;
        }
      });
      if (currentChecked && hasLaterChecked) {
        plus.style.removeProperty('display');
        plus.classList.remove('iconic-fbt-plus--hidden');
      } else {
        plus.style.setProperty('display', 'none', 'important');
        plus.classList.add('iconic-fbt-plus--hidden');
      }
    });
  }

  function updateSectionShellVisibility(scope) {
    var roots;
    if (scope && scope.matches && scope.matches('iconic-frequently-bought-together')) {
      roots = [scope];
    } else if (scope && scope.closest) {
      var root = scope.closest('iconic-frequently-bought-together');
      roots = root ? [root] : [];
    } else {
      roots = document.querySelectorAll('iconic-frequently-bought-together');
    }

    Array.prototype.forEach.call(roots, function (rootEl) {
      var wrapper = rootEl.querySelector('.iconic-fbt-wrapper');
      if (!wrapper) return;

      var hasContent = !!rootEl.querySelector('.iconic-fbt-inner, .iconic-fbt-empty, product-recommendations.iconic-fbt-recommendations');
      wrapper.style.display = hasContent ? '' : 'none';
    });
  }

  function loadRecommendationBlocks(scope) {
    var roots;
    if (scope && scope.matches && scope.matches('iconic-frequently-bought-together')) {
      roots = [scope];
    } else if (scope && scope.closest) {
      var root = scope.closest('iconic-frequently-bought-together');
      roots = root ? [root] : [];
    } else {
      roots = document.querySelectorAll('iconic-frequently-bought-together');
    }

    Array.prototype.forEach.call(roots, function (rootEl) {
      rootEl.querySelectorAll('product-recommendations.iconic-fbt-recommendations[data-fbt-url]').forEach(function (recommendationEl) {
        if (recommendationEl.dataset.iconicFbtLoading === 'true' || recommendationEl.dataset.iconicFbtLoaded === 'true') return;
        if (recommendationEl.querySelector('.iconic-fbt-inner, .iconic-fbt-empty')) {
          recommendationEl.dataset.iconicFbtLoaded = 'true';
          return;
        }

        recommendationEl.dataset.iconicFbtLoading = 'true';

        fetch(recommendationEl.dataset.fbtUrl)
          .then(function (response) { return response.text(); })
          .then(function (text) {
            var html = document.createElement('div');
            html.innerHTML = text;
            var nextContent = html.querySelector('product-recommendations.iconic-fbt-recommendations') || html.querySelector('product-recommendations');
            if (nextContent) {
              recommendationEl.innerHTML = nextContent.innerHTML;
            }
            recommendationEl.dataset.iconicFbtLoaded = 'true';
            recommendationEl.dataset.iconicFbtLoading = 'false';
            updateSectionShellVisibility(recommendationEl);
            var recSwiperEl = recommendationEl.querySelector('iconic-swiper');
            if (recSwiperEl) {
              (function initFbtRecSwiper() {
                var cdnScript = 'https://cdn.jsdelivr.net/gh/ArhamWebWorks/iconic-cdn/component-iconic-swiper.min.js';
                var cdnStyle = 'https://cdn.jsdelivr.net/gh/ArhamWebWorks/iconic-cdn/component-iconic-swiper.min.css';

                function doSwiperInit() {
                  var el = recommendationEl.querySelector('iconic-swiper');
                  if (!el) return;
                  var container = el.querySelector('.swiper-container') || el.querySelector('.swiper');
                  if (!container || container.classList.contains('swiper-initialized')) return;
                  var cfgAttr = el.getAttribute('data-config');
                  if (!cfgAttr) return;
                  try {
                    var cfg = JSON.parse(cfgAttr);
                    new Swiper(container, cfg);
                  } catch (e) { console.error('FBT rec swiper init error', e); }
                }

                if (!document.querySelector('link[href*="component-iconic-swiper"]')) {
                  var link = document.createElement('link');
                  link.rel = 'stylesheet';
                  link.href = cdnStyle;
                  link.media = 'all';
                  document.head.appendChild(link);
                }

                if (typeof Swiper !== 'undefined') {
                  setTimeout(doSwiperInit, 100);
                } else if (!document.querySelector('script[src*="component-iconic-swiper"]')) {
                  var script = document.createElement('script');
                  script.src = cdnScript;
                  script.onload = function () { setTimeout(doSwiperInit, 100); };
                  document.head.appendChild(script);
                } else {
                  var pollCount = 0;
                  var poll = setInterval(function () {
                    pollCount++;
                    if (typeof Swiper !== 'undefined') {
                      clearInterval(poll);
                      doSwiperInit();
                    } else if (pollCount > 30) {
                      clearInterval(poll);
                    }
                  }, 200);
                }
              })();
            }
            init();
            setTimeout(function () {
              var unbound = document.querySelectorAll('[data-iconic-fbt]:not([data-iconic-fbt-bound])');
              if (unbound.length) unbound.forEach(bindFbt);
            }, 300);
          })
          .catch(function (err) {
            console.error('FBT recommendations failed to load', err);
            recommendationEl.dataset.iconicFbtLoading = 'false';
            updateSectionShellVisibility(recommendationEl);
          });
      });
    });
  }

  function bindFbt(container) {
    if (!container || container.dataset.iconicFbtBound) return;
    container.dataset.iconicFbtBound = 'true';

    container.querySelectorAll('[data-fbt-variant-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        const row = select.closest('.iconic-fbt-row');
        if (row) {
          updateRowPrice(row, container.dataset.currencySymbol);
          updateRowSoldOut(row);
          var idx = row.getAttribute('data-index');
          var opt = select.options[select.selectedIndex];
          var imgUrl = opt && opt.getAttribute('data-image');
          if (idx !== null && imgUrl) {
            var visualRow = container.querySelector('.iconic-fbt-visual-row');
            var item = visualRow && visualRow.querySelector('.iconic-fbt-visual-item[data-fbt-index="' + idx + '"]');
            var img = item && item.querySelector('img');
            if (img) img.setAttribute('src', imgUrl);
            var rowImage = row.querySelector('[data-fbt-row-image] img');
            if (rowImage) rowImage.setAttribute('src', imgUrl);
          }
        }
        updateTotal(container);
      });
    });

    container.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-fbt-checkbox]')) {
        var c = e.target.closest('[data-iconic-fbt]');
        if (c) {
          updateTotal(c);
          updateVisualVisibility(c);
        }
      }
    });
    updateTotal(container);
    updateVisualVisibility(container);
    setTimeout(function () {
      updateVisualVisibility(container);
      updateSectionShellVisibility(container);
    }, 100);

    const addBtn = container.querySelector('[data-fbt-add-selected]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        const items = [];
        var rows = Array.prototype.slice.call(container.querySelectorAll('.iconic-fbt-row')).sort(function (a, b) {
          var ia = parseInt(a.getAttribute('data-index'), 10);
          var ib = parseInt(b.getAttribute('data-index'), 10);
          return (ia - ib);
        });
        rows.forEach(function (row) {
          const cb = row.querySelector('[data-fbt-checkbox]');
          if (!cb || !cb.checked) return;
          const v = getVariantFromRow(row);
          if (v && v.id && v.available) items.push({ id: String(v.id), quantity: 1 });
        });
        if (items.length === 0) return;

        addBtn.setAttribute('aria-disabled', 'true');
        addBtn.classList.add('loading');

        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (cart && typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(addBtn);
        }

        function openCartWithResponse(cartEl, response) {
          try {
            if (cartEl && response && response.sections && typeof cartEl.renderContents === 'function') {
              cartEl.renderContents(response);
              return true;
            }
          } catch (e) {
            console.warn('FBT: renderContents failed', e);
          }
          return false;
        }

        function addNext(index, lastResponse) {
          if (index >= items.length) {
            addBtn.removeAttribute('aria-disabled');
            addBtn.classList.remove('loading');
            var opened = cart && openCartWithResponse(cart, lastResponse);
            if (!opened && cart && cart.tagName.toLowerCase() === 'cart-drawer' && typeof cart.open === 'function') {
              var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
              var sectionIds = (typeof cart.getSectionsToRender === 'function')
                ? cart.getSectionsToRender().map(function (s) { return s.id; })
                : ['cart-drawer', 'cart-icon-bubble'];
              Promise.all(sectionIds.map(function (id) {
                return fetch(cartUrl + '?section_id=' + id).then(function (r) { return r.text(); });
              })).then(function (results) {
                var parser = new DOMParser();
                if (sectionIds.indexOf('cart-drawer') !== -1) {
                  var idx = sectionIds.indexOf('cart-drawer');
                  var drawerDoc = parser.parseFromString(results[idx], 'text/html');
                  var newDrawer = drawerDoc.querySelector('#CartDrawer');
                  var target = cart.querySelector('#CartDrawer');
                  if (newDrawer && target) target.innerHTML = newDrawer.innerHTML;
                }
                cart.classList.remove('is-empty');
                var bubbleIdx = sectionIds.indexOf('cart-icon-bubble');
                if (bubbleIdx !== -1 && results[bubbleIdx]) {
                  var bubbleDoc = parser.parseFromString(results[bubbleIdx], 'text/html');
                  var bubbleSection = bubbleDoc.querySelector('.shopify-section');
                  var bubbleEl = document.getElementById('cart-icon-bubble');
                  if (bubbleSection && bubbleSection.innerHTML && bubbleEl) bubbleEl.innerHTML = bubbleSection.innerHTML;
                }
                cart.open();
              }).catch(function () { window.location.href = CART_URL; });
            } else if (!opened) {
              window.location.href = CART_URL;
            }
            return;
          }
          var body = new FormData();
          body.append('id', String(items[index].id));
          body.append('quantity', '1');
          var isLast = index === items.length - 1;
          if (cart && typeof cart.getSectionsToRender === 'function') {
            cart.getSectionsToRender().forEach(function (s) {
              body.append('sections', s.id);
            });
            body.append('sections_url', window.location.pathname);
          } else {
            body.append('sections', 'cart-drawer');
            body.append('sections', 'cart-icon-bubble');
            body.append('sections_url', window.location.pathname);
          }

          fetch(CART_ADD_URL, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
            body: body,
          })
            .then(function (res) {
              return res.json().then(function (data) {
                return { ok: res.ok, data: data };
              }).catch(function () {
                return { ok: false, data: { status: res.status, message: 'Invalid response' } };
              });
            })
            .then(function (result) {
              var data = result.data;
              if (!result.ok || (data.status && data.message)) {
                addBtn.removeAttribute('aria-disabled');
                addBtn.classList.remove('loading');
                alert(data.message || 'Could not add item to cart.');
                return;
              }
              if (isLast) {
                addNext(index + 1, data);
              } else {
                setTimeout(function () { addNext(index + 1, null); }, 150);
              }
            })
            .catch(function (err) {
              console.error(err);
              addBtn.removeAttribute('aria-disabled');
              addBtn.classList.remove('loading');
              window.location.href = CART_URL;
            });
        }

        addNext(0, null);
      });
    }

    container.querySelectorAll('.iconic-fbt-row').forEach(function (row) {
      updateRowPrice(row, container.dataset.currencySymbol);
      updateRowSoldOut(row);
    });
    updateTotal(container);

    initGridSlider(container);
    initListVisualArrows(container);
    scheduleRestoreFbtGridNav(container);
    updateMobilePlusCenter(container);
    setTimeout(function () { updateMobilePlusCenter(container); }, 150);
  }

  function updateMobilePlusCenter(container) {
    if (!container || !container.style) return;
    if (window.innerWidth > 991) {
      container.style.removeProperty('--fbt-mobile-image-half');
      return;
    }
    var wrap = container.querySelector('.iconic-fbt-grid-swiper-wrap');
    var imgEl = wrap ? wrap.querySelector('.swiper-slide .iconic-fbt-row-image') : null;
    if (!imgEl) imgEl = container.querySelector('.iconic-fbt-list--grid .iconic-fbt-row-image');
    if (imgEl && imgEl.offsetHeight > 0) {
      container.style.setProperty('--fbt-mobile-image-half', (imgEl.offsetHeight / 2) + 'px');
    }
  }

  /**
   * Swiper may move prev/next into the carousel (blue chevrons on slide edges).
   * Keep circular controls in .iconic-fbt-grid-swiper-arrows like the reference design.
   */
  function restoreFbtGridNavToBar(scope) {
    var wraps;
    if (scope && scope.querySelectorAll) {
      wraps = scope.querySelectorAll('.iconic-fbt-grid-swiper-wrap');
    } else {
      wraps = document.querySelectorAll('.iconic-fbt-grid-swiper-wrap');
    }
    Array.prototype.forEach.call(wraps, function (wrap) {
      var bar = wrap.querySelector('.iconic-fbt-grid-swiper-arrows');
      if (!bar) return;
      var swiperRoot = wrap.querySelector('.iconic-fbt-grid-swiper.swiper') || wrap.querySelector('.iconic-fbt-grid-swiper.swiper-container') || wrap.querySelector('.iconic-fbt-grid-swiper');
      if (!swiperRoot || bar.contains(swiperRoot)) return;
      swiperRoot.querySelectorAll('.swiper-button-prev.iconic-fbt-swiper-arrow, .swiper-button-next.iconic-fbt-swiper-arrow').forEach(function (btn) {
        bar.appendChild(btn);
      });
      swiperRoot.querySelectorAll('.swiper-button-prev:not(.iconic-fbt-swiper-arrow), .swiper-button-next:not(.iconic-fbt-swiper-arrow)').forEach(function (btn) {
        btn.style.setProperty('display', 'none', 'important');
        btn.setAttribute('aria-hidden', 'true');
      });
    });
  }

  function scheduleRestoreFbtGridNav(scope) {
    restoreFbtGridNavToBar(scope);
    setTimeout(function () { restoreFbtGridNavToBar(scope); }, 50);
    setTimeout(function () { restoreFbtGridNavToBar(scope); }, 200);
    setTimeout(function () { restoreFbtGridNavToBar(scope); }, 600);
  }

  function initListVisualArrows(container) {
    container.querySelectorAll('[data-fbt-list-visual-arrows]').forEach(function (arrowWrap) {
      var wrap = arrowWrap.closest('.iconic-fbt-list-visual-wrap');
      if (!wrap) return;
      var row = wrap.querySelector('[data-fbt-visual-row]');
      var prevBtn = arrowWrap.querySelector('.iconic-fbt-list-visual-prev');
      var nextBtn = arrowWrap.querySelector('.iconic-fbt-list-visual-next');
      if (!row || !prevBtn || !nextBtn) return;
      if (wrap.dataset.fbtListArrowsInited === 'true') return;
      wrap.dataset.fbtListArrowsInited = 'true';

      row.style.overflowX = 'auto';
      row.style.flexWrap = 'nowrap';
      row.style.scrollBehavior = 'smooth';

      function updateArrowState() {
        var scrollLeft = row.scrollLeft;
        var maxScroll = row.scrollWidth - row.clientWidth;
        prevBtn.disabled = scrollLeft <= 0;
        nextBtn.disabled = maxScroll <= 0 || scrollLeft >= maxScroll - 1;
      }

      var scrollStep = function () {
        var w = row.clientWidth * 0.8;
        return Math.max(120, w);
      };

      prevBtn.addEventListener('click', function () {
        if (prevBtn.disabled) return;
        row.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        if (nextBtn.disabled) return;
        row.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
      row.addEventListener('scroll', updateArrowState);
      window.addEventListener('resize', updateArrowState);
      updateArrowState();
    });
  }

  function initGridSlider(container) {
    var list = container.querySelector('.iconic-fbt-list--grid-slider') || container.querySelector('.iconic-fbt-list[data-fbt-grid-slider="true"]');
    if (!list || list.dataset.fbtGridSliderInited === 'true') return;

    list.setAttribute('data-fbt-grid-slider', 'true');
    var space = parseInt(list.dataset.fbtSliderSpace || '16', 10) || 16;
    list.style.gap = space + 'px';

    var rows = list.querySelectorAll('.iconic-fbt-row');
    var slideCount = rows.length;
    if (slideCount === 0) return;

    list.dataset.fbtGridSliderInited = 'true';
    var controls = container.querySelector('[data-fbt-slider-controls]');
    var prevBtn = controls ? controls.querySelector('[data-fbt-slider-prev]') : null;
    var nextBtn = controls ? controls.querySelector('[data-fbt-slider-next]') : null;
    var paginationEl = controls ? controls.querySelector('[data-fbt-slider-pagination]') : null;

    function getScrollStep() {
      var first = rows[0];
      if (!first) return list.clientWidth;
      var plus = first.nextElementSibling;
      var plusW = (plus && plus.classList.contains('iconic-fbt-plus-sep')) ? plus.offsetWidth : 0;
      return first.offsetWidth + plusW + space;
    }

    function updateControls() {
      var scrollLeft = list.scrollLeft;
      var maxScroll = list.scrollWidth - list.clientWidth;
      if (prevBtn) {
        prevBtn.disabled = scrollLeft <= 2;
      }
      if (nextBtn) {
        nextBtn.disabled = maxScroll <= 2 || scrollLeft >= maxScroll - 2;
      }
      if (paginationEl && paginationEl.children.length) {
        var step = getScrollStep();
        var index = step > 0 ? Math.round(scrollLeft / step) : 0;
        index = Math.min(index, slideCount - 1);
        [].forEach.call(paginationEl.children, function (dot, i) {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-selected', i === index);
        });
      }
    }

    if (paginationEl && slideCount > 0) {
      for (var i = 0; i < slideCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('data-fbt-dot', '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        dot.classList.toggle('is-active', i === 0);
        (function (idx) {
          dot.addEventListener('click', function () {
            var step = getScrollStep();
            list.scrollTo({ left: idx * step, behavior: 'smooth' });
          });
        })(i);
        paginationEl.appendChild(dot);
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var step = getScrollStep();
        list.scrollBy({ left: -step, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var step = getScrollStep();
        list.scrollBy({ left: step, behavior: 'smooth' });
      });
    }

    list.addEventListener('scroll', function () {
      updateControls();
    });
    window.addEventListener('resize', function () {
      updateControls();
    });
    updateControls();

    var autoplay = list.dataset.fbtSliderAutoplay === 'true';
    var speed = parseInt(list.dataset.fbtSliderAutoplaySpeed || '5', 10) * 1000 || 5000;
    var autoplayTimer = null;
    if (autoplay && slideCount > 1) {
      function runAutoplay() {
        autoplayTimer = setInterval(function () {
          var maxScroll = list.scrollWidth - list.clientWidth;
          if (list.scrollLeft >= maxScroll - 2) {
            list.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            list.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
          }
        }, speed);
      }
      runAutoplay();
      list.addEventListener('mouseenter', function () {
        if (autoplayTimer) clearInterval(autoplayTimer);
      });
      list.addEventListener('mouseleave', runAutoplay);
      list.addEventListener('touchstart', function () {
        if (autoplayTimer) clearInterval(autoplayTimer);
      }, { passive: true });
    }
  }

  var mobilePlusResizeTimer = null;
  function onResizeMobilePlus() {
    if (mobilePlusResizeTimer) clearTimeout(mobilePlusResizeTimer);
    mobilePlusResizeTimer = setTimeout(function () {
      document.querySelectorAll('[data-iconic-fbt]').forEach(updateMobilePlusCenter);
      restoreFbtGridNavToBar(document);
      mobilePlusResizeTimer = null;
    }, 100);
  }

  function init() {
    loadRecommendationBlocks();
    document.querySelectorAll('[data-iconic-fbt]').forEach(bindFbt);
    updateSectionShellVisibility();
    window.removeEventListener('resize', onResizeMobilePlus);
    window.addEventListener('resize', onResizeMobilePlus);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    init();
    setTimeout(init, 150);
  });

  var observer = new MutationObserver(function (mutations) {
    var hasAddedNodes = false;
    mutations.forEach(function (m) {
      if (m.addedNodes.length) hasAddedNodes = true;
    });
    if (!hasAddedNodes) return;
    loadRecommendationBlocks();
    updateSectionShellVisibility();
    restoreFbtGridNavToBar(document);
    if (document.querySelector('[data-iconic-fbt]:not([data-iconic-fbt-bound])')) init();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();